const features = [
  {
    title: "Multi-Warehouse Management",
    desc: "Manage multiple warehouses with precise location and bin-level tracking for optimal inventory control across all facilities.",
    icon: "/images/warehouse/MultiWarehouseManagement.svg",
  },
  {
    title: "Barcode Scanning System",
    desc: "Scan items and warehouse bins using mobile devices for accurate tracking, faster operations, and reduced manual errors.",
    icon: "/images/warehouse/barcode-scanning.svg",
  },
  {
    title: "Stock Receipt & Returns",
    desc: "Automate supplier receipts and customer returns processing with digital documentation and real-time inventory updates.",
    icon: "/images/warehouse/stock-receipt.svg",
  },
  {
    title: "Delivery Trip Planning",
    desc: "Plan optimized delivery routes, generate pick lists, and manage cage loading for efficient distribution operations.",
    icon: "/images/warehouse/trip-planning.svg",
  },
  {
    title: "Field Delivery Operations",
    desc: "Mobile app for delivery teams to manage invoices, track deliveries, and update status (full/partial/rejected) in real-time.",
    icon: "/images/warehouse/field-delivery.svg",
  },
  {
    title: "Real-time Vehicle Tracking",
    desc: "Monitor delivery trucks in real-time with complete visibility of field operations and delivery progress.",
    icon: "/images/warehouse/vehicle-tracking.svg",
  },
];

export function Features() {
  return (
    <div className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            Smart Warehouse & Delivery Features
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive features designed to automate and optimize your entire supply chain operations
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {features.map((feature, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 group border border-gray-100"
            >
              {/* Image Container with Overlay */}
              <div className="relative h-48 overflow-hidden">
                <div
                  className="h-full bg-cover bg-center group-hover:scale-110 transition-transform duration-500"
                  style={{ backgroundImage: `url(${feature.icon})` }}
                ></div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-4 left-4">
                  <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center shadow-lg">
                    <span className="text-white font-bold text-sm">{i + 1}</span>
                  </div>
                </div>
              </div>
              
              {/* Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-3 group-hover:text-blue-600 transition-colors">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">{feature.desc}</p>
                
                {/* Feature Tags */}
                <div className="mt-4 flex flex-wrap gap-2">
                  {feature.title.includes("Stock Receipt") && (
                    <span className="text-xs bg-red-100 text-red-800 px-3 py-1 rounded-full font-medium">
                      Stock
                    </span>
                  )}
                  {feature.title.includes("Warehouse") && (
                    <span className="text-xs bg-blue-100 text-blue-800 px-3 py-1 rounded-full font-medium">
                      Inventory
                    </span>
                  )}
                  {feature.title.includes("Barcode") && (
                    <span className="text-xs bg-green-100 text-green-800 px-3 py-1 rounded-full font-medium">
                      Automation
                    </span>
                  )}
                  {feature.title.includes("Delivery") && (
                    <span className="text-xs bg-purple-100 text-purple-800 px-3 py-1 rounded-full font-medium">
                      Logistics
                    </span>
                  )}
                  {feature.title.includes("Tracking") && (
                    <span className="text-xs bg-pink-100 text-pink-800 px-3 py-1 rounded-full font-medium">
                      Real-time
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}